module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Mezzi_di_Lavoro_in_Azione-CL.7c88dce9.svg";